module.exports = __webpack_public_path__ + "static/media/firebase.c24b6b9c.png";